module.exports = __webpack_public_path__ + "img/yiou.31fa57fc.png";